import InfiniteScroll from 'react-infinite-scroll-component';
import styled from 'styled-components';

export const ScrollableWrapper = styled.div`
  overflow-y: auto;
  height: 100%;
`;

export const ProductsWrapper = styled(InfiniteScroll).attrs(({ scrollableTarget }) => ({
  scrollableTarget,
}))`
  display: grid;
  grid-template-columns: repeat(4, minmax(150px, 1fr));
  gap: 10px;
  padding: 10px;
  min-height: 0;
  @media (max-width: 1200px) {
    grid-template-columns: repeat(3, minmax(150px, 1fr));
  }
  @media (max-width: 992px) {
    grid-template-columns: repeat(2, minmax(150px, 1fr));
  }
  @media (max-width: 767px) {
    grid-template-columns: minmax(150px, 1fr);
  }
`;

export const EmptyState = styled.div`
  width: 100%;
  padding: 64px 20px 40px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  text-align: center;
  color: #6c757d;
`;
